// date time format
export const renderDateTime = moment => moment.format('DD MMM YYYY hh:mm A');
